import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { weekdays } from '@/mocks/schedule';

export default function ScheduleSection() {
  const [activeDay, setActiveDay] = useState(weekdays[0].day);
  const current = weekdays.find((w) => w.day === activeDay) ?? weekdays[0];

  return (
    <section id="schedule" className="w-full bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追番时间表"
          title="按星期安排观看，不再错过更新"
          desc="切换星期即可查看当天更新的作品与时间点。表内条目已按播出时段排序，适合用来规划每天的观看节奏，避免同时开好几部却都追不下去。"
        />

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-56 shrink-0">
            <div className="flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0">
              {weekdays.map((w) => (
                <button
                  key={w.day}
                  type="button"
                  onClick={() => setActiveDay(w.day)}
                  className={`px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors text-left ${
                    activeDay === w.day
                      ? 'bg-secondary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-50 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
                  }`}
                >
                  <span className="inline-flex items-center gap-2">
                    <i className="ri-calendar-2-line"></i>
                    {w.day}
                  </span>
                  <span className={`hidden lg:block mt-0.5 text-xs font-normal ${activeDay === w.day ? 'text-background-50/80' : 'text-foreground-400'}`}>
                    {w.items.length} 部更新
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="flex-1 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
              <h3 className="font-heading text-lg md:text-xl text-foreground-950">{current.day} 更新时间表</h3>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                {current.items.length} 部
              </span>
            </div>
            <ul className="divide-y divide-background-200">
              {current.items.map((item) => (
                <li key={item.title} className="flex items-center gap-4 px-5 py-4">
                  <span className="w-16 md:w-20 shrink-0 text-center rounded-md bg-accent-100 py-2 font-heading text-sm md:text-base text-accent-900">
                    {item.time}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm md:text-base font-medium text-foreground-900 truncate">{item.title}</p>
                    <p className="mt-0.5 text-xs md:text-sm text-foreground-500 truncate">{item.note}</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400 text-xl"></i>
                </li>
              ))}
            </ul>
            <div className="px-5 py-4 bg-background-100 border-t border-background-200">
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                <i className="ri-information-line mr-1"></i>
                时间表按常规更新时段整理，节假日或特别企划可能有调整，实际以条目说明为准。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}